import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Dashboard from '../../../../../components/dashboard/Dashboard';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';

function ClientAppDashboard() {
  return <Dashboard />;
}

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ClientAppDashboard,
  staticData: {
    configPageId: 'dashboard',
    isClientRoute: true,
    meta: {
      title: 'Client Dashboard | Ledgible',
    },
  },
});
